import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BannerBlogs from "../components/BannerBlogs";
import BlogCards from "../components/BlogCards";

export default function Blogs() {
  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
        <Header />
        <BannerBlogs />
        <BlogCards />
        <Footer />
    </main>
  );
}